import React from 'react'

const BrokerStatusRenderer = (props: any) => {
    return (
        <div className={"cellRenderHeader"}>
            <div className={`badge ${["active", "done", "closed"].includes(props?.value?.toLowerCase()) ? 
                'bg-success-light' : 
                'bg-danger-light'}`}
            >{(props.value)}</div>
        </div>
    )
}

export default BrokerStatusRenderer;